// extracted by mini-css-extract-plugin
module.exports = {"adaptiveText":"AdaptiveText_adaptiveText__jSrm5"};